import React from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";
import StatusView from "../../atoms/StatusView/StatusView";

const AcessoNegado: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate("/");
  };

  return (
    <StatusView
      code="403"
      title="Acesso negado"
      description="Voce nao possui permissao para acessar esta pagina."
      actionLabel="Voltar"
      onAction={handleBack}
      icon={<LockOutlinedIcon fontSize="large" />}
    />
  );
};

export default AcessoNegado;
